import React from "react";
import RequestEngine from "../../core/RequestEngine";
import strings from "../../core/translate";
import { apiErrorMessage } from "../../shared/api-error";
import {
  FormSection,
  FormGrid,
  SelectField,
  FormAlert,
  FormActions,
} from "../../components/Form/FormKit";

// Adds / edits one service offered by a garage.
export default class BranchServiceForm extends React.Component {
  constructor(props) {
    super(props);
    const item = props.item || {};
    this.state = {
      id: item.id || "",
      version: item.version,
      serviceId: item.service ? item.service.id : "",
      serviceList: [],
      loading: false,
      error: "",
      fieldError: "",
    };
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    this.fetchServices();
  }

  fetchServices = async () => {
    const response = await this.engine.getItemlistDirect("services");
    if (response) {
      this.setState({
        serviceList: response.data.items.map((service) => ({
          value: service.id,
          label: service.name,
        })),
      });
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { id, version, serviceId } = this.state;

    if (!serviceId) {
      this.setState({ fieldError: `${strings.select} ${strings.service}` });
      return;
    }

    this.setState({ loading: true, error: "", fieldError: "" });
    const pathname = `merchants-branches/${this.props.branchId}/services`;

    try {
      const response = id
        ? await this.engine.updateItem(pathname, id, { serviceId, version })
        : await this.engine.saveItem(pathname, { serviceId });

      if (response && (response.status === 200 || response.status === 201)) {
        this.setState({ loading: false });
        this.props.onSaved(response.data);
        return;
      }
    } catch (err) {
      this.setState({ error: apiErrorMessage(err) });
    }
    this.setState({ loading: false });
  };

  render() {
    const { serviceId, serviceList, loading, error, fieldError } = this.state;

    return (
      <form className="mform" onSubmit={this.handleSubmit}>
        <FormSection title={strings.service} icon="nc-icon nc-settings">
          <FormGrid full>
            <SelectField
              label={strings.service}
              required
              value={serviceId}
              options={serviceList}
              onChange={(value) => this.setState({ serviceId: value })}
              error={fieldError}
              help={strings.branch_service_form_hint}
            />
          </FormGrid>
        </FormSection>

        <FormAlert>{error}</FormAlert>
        <FormActions onCancel={this.props.onCancel} loading={loading} />
      </form>
    );
  }
}
